import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { CanvasEdge, CanvasNode } from '../../Canvas';

export const useUpdateCanvas = () => {
  const { dispatch } = useWorkFlowCanvas();

  return useCallback(
    (nodes: CanvasNode[], edges: CanvasEdge[]) => {
      dispatch({
        type: 'UPDATE',
        payload: { nodes, edges },
      });
    },
    [dispatch],
  );
};
